// Registri modul & widget belajar interaktif per mapel.
import { MODUL_BILANGAN } from './modul/bilangan.js';
import { MODUL_GEOMETRI } from './modul/geometri.js';
import { MODUL_DATA } from './modul/data.js';
import { WIDGET_PECAHAN } from './widget/pecahan.js';
import { WIDGET_BILANGAN } from './widget/bilangan.js';
import { WIDGET_GEOMETRI } from './widget/geometri.js';
import { WIDGET_DATA } from './widget/data.js';
import { WIDGET_BAHASA } from './widget/bahasa.js';
import { MODUL_BI } from './modul/bahasa-indonesia.js';

export const ELEMEN_URUT = ['Bilangan', 'Geometri & Pengukuran', 'Data', 'Teks Informasi', 'Teks Fiksi'];
export const WIDGET = { ...WIDGET_PECAHAN, ...WIDGET_BILANGAN, ...WIDGET_GEOMETRI, ...WIDGET_DATA, ...WIDGET_BAHASA };
export const MODUL = { matematika: [...MODUL_BILANGAN, ...MODUL_GEOMETRI, ...MODUL_DATA], 'bahasa-indonesia': MODUL_BI };
